<template>
  <div class="wrapper-content w-100">
    <h1>{{ $t('mail_template') }}</h1>
    <LmForm ref="lmForm">
      <LmTextInput
        v-model="form.name"
        :v="$v.form.name"
        :label="$t('name')"
        :placeholder="$t('name')"
      />
      <LmTextArea
        id="mjml-template"
        v-model="form.template"
        :v="$v.form.template"
        rows="11"
        :maxLength="20000"
        label="MJML Template"
        :placeholder="`
  <mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>
        `.trim()"
      />
      <LmSelect
        v-model="form.published"
        :v="$v.form.published"
        :options="optionsPublish"
        label="Publicado"
        />
      <LmButton type="button" value="Previsualizar template" @click.native="preview()"/>
      <div class="row">
        <div class="col-12">
          <LmButton
            type="button"
            buttonClass="btn-secondary"
            :value="$t('go_back')"
            @click="onCancel"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
          />
          <LmButton
            type="button"
            :value="$t('Save')"
            :isProcessing="isFormProcessing"
            @click.native="submit()"
            buttonClass="btn-primary"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
          />
        </div>
      </div>
    </LmForm>
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal"/>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal'

import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
export default {
  mixins: [lmToasts],
  data () {
    return {
      optionsPublish: {
        content: [{ value: true, text: 'Si' }, { value: false, text: 'No' }]
      },
      form: {
        name: '',
        template: `<mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>`,
        type: 'email',
        published: false
      },
      isFormProcessing: false,
      initialForm: {}
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmTextArea,
    LmSelect,
    LmButton,
    LmTemplatePreviewModal
  },
  validations: {
    form: {
      name: {
        required
      },
      published: {
        required
      },
      template: {
        required
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    previewTemplateEndpoint: {
      type: String,
      default: `${process.env.VUE_APP_API_URL}templates/new/`
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  methods: {
    onCancel () {
      this.$router.go(-1)
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`)
      this.form = res.data
    },
    async preview () {
      await this.$refs.lmForm.validationForm(this.$v)
      try {
        const previewData = {
          name: this.form.name,
          template: this.form.template.trim(),
          type: this.form.type,
          preview: true,
          published: this.form.published
        }
        const response = await axios.post(
          this.previewTemplateEndpoint,
          previewData
        )
        const template = JSON.parse(response.data.template).html
        this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(template)
      } catch (error) {
        console.log(error)
      }
    },
    async submit () {
      try {
        this.isFormProcessing = true
        await this.$refs.lmForm.validationForm(this.$v)

        // Condicional creado para mejorar la logica del template sin crear uno nuevo y manteniendo
        // compatibilidad hacia atrás
        if (this.isOnEditMode) {
          const dataToSendToTheServer = {
            name: this.form.name,
            template: this.form.template.trim(),
            type: this.form.type,
            published: this.form.published
          }
          await axios.put(
            `${this.serviceEndpoint}/${this.$route.params.id}`,
            dataToSendToTheServer
          )
        } else {
          // Se comporta como se espera en versiones anteriores de emailtemplates
          const dataToSendToTheServer = {
            name: this.form.name,
            template: this.form.template.trim(),
            type: this.form.type,
            published: this.form.published
          }
          await axios.post(
            this.serviceEndpoint,
            dataToSendToTheServer
          )
        }

        this.lmToastSuccessMessage(
          `${this.$t('saved_successfully')} '${this.form.name}'`,
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  async created () {
    this.initialForm = JSON.stringify(this.form)
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
